export default __webpack_public_path__ + "static/media/active-not-color.0e4e28bc.svg";